import { Model, Attr, PersistedSpraypaintRecord, HasOne } from 'spraypaint';
import {
  ApplicationRecord,
  getCSRFHeaders,
  Media,
} from 'spa-ionata-admin/lib/models';

// Inject the two attributes into the main Media class, so spraypaint deserializes them
Attr(Media, 'label');
Attr(Media, 'uuid');

export type PersistedMedia = PersistedSpraypaintRecord<MediaExt>;

@Model()
export default class MediaExt extends Media {
  static jsonapiType = 'media';

  @Attr() label!: string;

  @Attr() uuid!: string;

  // get gradient(): 'bottom' | 'top' | undefined {
  //   return undefined;
  // }

  @HasOne() cloneFrom?: Media;

  async clone(postUrl: string) {
    if (!this.cloneFrom) {
      throw new Error('no cloneFrom');
    }
    if (!this.cloneFrom.id) {
      throw new Error('cloneFrom with no id');
    }
    if (!postUrl) {
      throw new Error('no postUrl');
    }
    const headers: Hash<string> = {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
      ...getCSRFHeaders(),
    };
    const data = this.asJSON(['cloneFrom.id']);
    const res = await fetch(postUrl, {
      method: 'POST',
      headers,
      body: JSON.stringify(data),
      credentials: 'include',
    });
    const jsonResult = await res.json();
    return MediaExt.fromJsonapi(jsonResult.data, jsonResult) as PersistedMedia;
  }

  static getPersistedMediasLookupTable(medias: PersistedMedia[]) {
    const table: Hash<PersistedMedia> = {};
    medias.forEach(media => {
      // NOTE: we assume the id and uuid will never overlap
      table[media.id] = media;
      if (media.uuid) {
        table[media.uuid] = media;
      }
    });
    return table;
  }

  static getMediasUUIDs(
    medias: PersistedMedia[],
    uuidsMap?: Hash<PersistedMedia>,
    onMissingUUID?: (media: PersistedMedia) => string,
  ) {
    const missingHandler = onMissingUUID || noUUID;
    return medias.map<string>(media => {
      let { uuid } = media;
      if (!uuid && uuidsMap) {
        uuid = uuidsMap[media.id]?.uuid;
      }
      if (!uuid) {
        uuid = missingHandler(media);
      }
      return uuid;
    });
  }
}

// A hacky way to override the already registered Media factory
(ApplicationRecord.typeRegistry as HashAny)['_typeMap']['media'] = MediaExt;

function noUUID(): never {
  throw new Error('no uuid');
}
